import { AddAlbum as AddAlbumModule } from "../modules/AddAlbum/AddAlbum";

const AddAlbum = () => {
  return <AddAlbumModule />;
};

export default AddAlbum;
